import { SxProps, Theme } from '@mui/material/styles';

export const titleTendenceSX: SxProps<Theme> = {
	fontWeight: {
        xs: '900',
        md: 'bold',
    },
	fontSize: {
        xs: 'var(--font-size-md)',
        md: 'var(--font-size-xl)',
    },
    textAlign: {
        xs: 'center',
        md: 'start',
    },
    color: 'text.primary',
};

export const subtitleTendenceSX: SxProps<Theme> = {
	fontWeight: 'normal',
	fontSize: 'var(--font-size-default)',
    textAlign: {
        xs: 'center',
        md: 'start',
    },
    color: 'text.primary',
};
